"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoisonCloudAbilityHandler = exports.PoisonCloudActorAbilityFactory = exports.PoisonCloudAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const __1 = require("../..");
const Duration_1 = require("../../core/Duration");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const Random_1 = require("../../utils/Random");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class PoisonCloudAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.PoisonCloud;
        this.__typeName = "PoisonCloud";
    }
}
exports.PoisonCloudAbilityArgs = PoisonCloudAbilityArgs;
let PoisonCloudActorAbilityFactory = class PoisonCloudActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("PoisonCloud", "AllEnemies", 2);
    }
};
PoisonCloudActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("PoisonCloud")
], PoisonCloudActorAbilityFactory);
exports.PoisonCloudActorAbilityFactory = PoisonCloudActorAbilityFactory;
let PoisonCloudAbilityHandler = class PoisonCloudAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const enemies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        container.applyProjectileAttacksWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            projectiles: enemies.map((enemyId) => ({
                targetId: enemyId,
                path: "arc",
                type: "GreenOrb",
                jitter: (0, Random_1.random)(50, 500),
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Nature", 50)
                ]
            })),
            onHit(sequence, _attack, _damage, projectile) {
                container.applyDebuff({
                    attackerId: ability.invokerId,
                    targetId: projectile.targetId,
                    duration: Duration_1.Duration.Turns(2),
                    effect: new __1.PoisonedEffectArgs("Power", 10),
                    sequence,
                    onApplied(sequence) {
                        sequence.push(new __1.InstantVfxStepArgs(new LocationSelector_1.ActorVicinityLocationSelector(projectile.targetId, "front", "bottom"), "BloodyPoisonCloud"));
                    },
                    onResisted(sequence) {
                        sequence.push(new __1.InstantVfxStepArgs(new LocationSelector_1.ActorVicinityLocationSelector(projectile.targetId, "front", "bottom", "behind"), "BloodyPoisonCloud"));
                    }
                });
            }
        });
    }
};
PoisonCloudAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.PoisonCloud)
], PoisonCloudAbilityHandler);
exports.PoisonCloudAbilityHandler = PoisonCloudAbilityHandler;
